import module from '@kendu/ui/module'
import './style.scss'

export class KdTopbarComponent {}

module.component('kdTopbar', {
  controller: KdTopbarComponent,
})



// WEBPACK FOOTER //
// ./src/kendu/ui/components/kd-topbar/component.js